import { render, staticRenderFns } from "./AdsReportDetails.vue?vue&type=template&id=2a020718"
import script from "./AdsReportDetails.vue?vue&type=script&lang=js"
export * from "./AdsReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports